import React, { useState } from 'react';
import { Box, Button, Input, Select, Text, VStack, Heading } from '@chakra-ui/react';

const DziennikOcen = () => {
    const [dziennik, setDziennik] = useState({
        sprawdzian: {},
        kartkowka: {},
        odpowiedzUstna: {}
    });

    const [osoba, setOsoba] = useState('');
    const [ocena, setOcena] = useState('');
    const [kategoria, setKategoria] = useState('sprawdzian');

    const dodajOcene = () => {
        if (!dziennik[kategoria][osoba]) {
            dziennik[kategoria][osoba] = [];
        }
        dziennik[kategoria][osoba].push(ocena);
        setDziennik({ ...dziennik });
        setOsoba('');
        setOcena('');
    };

    const wyswietlDziennik = () => {
        return Object.keys(dziennik).map(kategoria => (
            <Box key={kategoria} mt={4}>
                <Heading size="md">Kategoria: {kategoria}</Heading>
                {Object.keys(dziennik[kategoria]).map(osoba => (
                    <Text key={osoba}>
                        {osoba}: {dziennik[kategoria][osoba].join(', ')}
                    </Text>
                ))}
            </Box>
        ));
    };

    return (
        <Box p={4}>
            <Heading mb={4}>Dziennik Ocen</Heading>
            <VStack spacing={4} align="stretch">
                <Input
                    placeholder="Osoba"
                    value={osoba}
                    onChange={(e) => setOsoba(e.target.value)}
                />
                <Input
                    placeholder="Ocena"
                    value={ocena}
                    onChange={(e) => setOcena(e.target.value)}
                />
                <Select
                    value={kategoria}
                    onChange={(e) => setKategoria(e.target.value)}
                >
                    <option value="sprawdzian">Sprawdzian</option>
                    <option value="kartkowka">Kartkówka</option>
                    <option value="odpowiedzUstna">Odpowiedź Ustna</option>
                </Select>
                <Button onClick={dodajOcene} colorScheme="blue">Dodaj Ocene</Button>
            </VStack>
            <Box mt={8}>
                {wyswietlDziennik()}
            </Box>
        </Box>
    );
};

export default DziennikOcen;